import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["prefixCls"];
import React from 'react';
import PropTypes from 'prop-types';
import RCMonthCalendar from 'rc-calendar/lib/MonthCalendar';
import styles from '../../input.module.scss';
var Calendar = function Calendar(_ref) {
  var prefixCls = _ref.prefixCls,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-picker-container ").concat(styles.monthPicker)
  }, /*#__PURE__*/React.createElement(RCMonthCalendar, _extends({
    prefixCls: prefixCls
  }, rest)));
};
Calendar.propTypes = {
  prefixCls: PropTypes.string.isRequired
};
export default Calendar;